import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium text-primary-800">
            <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap font-label text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}